import { api } from './api'

export const fetchTag = (query) => api.get('/tag', query)
export const addTag = (tag) => api.post('/tag', tag)
export const updateTag = (tag) => api.put(`/tag/${tag.id}`, tag)
export const deleteTag = (tag) => api.delete(`/tag/${tag.id}`)
